import UspBarStatic from "../../UspBarStatic/UspBarStatic";
const FooterCarDetail = () => {
  return (
    <footer
      className={`bg-blue-dark text-white  lg:min-h-[82px] min-h-[40px]`}
      style={{ contentVisibility: "auto" }}
    >
      <UspBarStatic className={"!mt-0"} isFooter={true} />
    </footer>
  );
};

export default FooterCarDetail;
